<template>
  <div class="payout-detail-modal">
    <el-dialog :title="$t('data.payout_details')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card" @open="getDetailInfo">
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num color-main-linear-blue"> {{ $store.getters.currency }}  {{ merchantInfo.po_trans_amount | toDivideWithDot }}</div>
        </div>
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num color-main-linear-blue">{{ $store.getters.currency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title mb-12 mt-12">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_created') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_create_time }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_completed') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title mb-12 mt-36">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.merchant_order_id') }}</span>
        <span class="content-gray">{{ merchantInfo.merchant_order_id }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remitting_bank') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.remittance_account') }}</span>
        <span class="content-gray">{{ merchantInfo.sender_bank_account | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_name | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_channel }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.recipient_account') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_account | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.beneficiary_mobile') }}</span>
        <span class="content-gray">{{ merchantInfo.mobile | strAesDecryptAndAsterisk }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('system.remark') }}</span>
        <span class="content-gray">{{ merchantInfo.remark }}</span>
      </div>

      <div v-if="merchantInfo.po_trans_status === TRANSACTION_STATUS['fail']" class="item">
        <span class="item-left content-blue">{{ $t('data.fail_reason') }}</span>
        <span class="content-gray">{{ merchantInfo.fail_reason }}</span>
      </div>

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.payment_channel') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code }}</span>
      </div> -->

      <!-- <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.app_name') }}</span>
        <span class="content-gray">{{ merchantInfo.app_name }}</span>
      </div> -->

      <el-tag :type="getPOTransactionStatusType(merchantInfo.po_trans_status)" min-width="150" class="payout-status tag-custom"> {{ getPOTransactionStatusLabel(merchantInfo.po_trans_status,merchantInfo.refund_type) }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { fetchPayoutDetail } from '@/api/customer-service/customer-service'
import { poTransStatusWithRefundMap } from '@/utils/maps'
import { cryptoJSAesDecrypt } from '@/utils/encrypt'
export default {
  name: 'Po_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: String,
      default: '0'
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      fail: 4
    }
    return {
      dialogTableVisible: false,
      listLoading: false,
      merchantInfo: { merchant: { merchant_basic_info: {}}, disbursement_fee: {}}
    }
  },
  computed: {
    getPOTransactionStatusLabel() {
      return function(value, refund_type) {
        if (refund_type === 2) {
          value = 99
        }
        return poTransStatusWithRefundMap(value).label
      }
    },
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusWithRefundMap(value).type
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      const params = { transaction_id: this.detailId }
      fetchPayoutDetail(params).then(res => {
        this.merchantInfo = res.data
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style scoped lang="scss">
.total{
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .total-item{
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(54, 66, 80, 0.20);
    &:nth-child(1){
      margin-right: 24px;
    }
  }
  &-title{
    color: #364250;
    font-size: 12px;
    font-weight: 600;
  }
  &-num{
    margin-top: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #364250;
}
.content-gray{
  flex: 1;
  text-align: right;
  font-weight: 500;
  font-size: 14px;
  line-height: 15px;
  color: #488CE8;
}

.payout-detail-modal{
  .payout-status{
    text-align: center;
    position: absolute;
    top: 12px;
    left: 160px;
  }
}
</style>
